import { DetailsInfoComponent } from './details-info.component';

export default DetailsInfoComponent;
